import { render, staticRenderFns } from "./ThreeDotIcon.vue?vue&type=template&id=72850e30"
import script from "./ThreeDotIcon.vue?vue&type=script&lang=ts"
export * from "./ThreeDotIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports